// import reachGoal from "../../libs/reach-goal"

Vue.directive("goal", function (el, binding) {
    if (!binding.arg) throw new Error('Директива v-goal должна иметь аргумент указывающий на событие, по которому сработает цель.');

    if (binding.modifiers.virtual) {
        el.__vue__.$on(binding.arg, () => reachGoal(binding.value, 'virtual'));
    } else {
        el.__vue__.$on(binding.arg, () => reachGoal(binding.value, 'submit'));
    }
});